import { getVersion } from '../../../api/versionApi'
import VersionDescriptions from '../../../components/versions/version-descriptions/version-descriptions'
import { IVersion } from '../share-type'
import { Space } from 'antd'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

const Version = () => {
  const { versionId } = useParams()
  const [version, setVersion] = useState<IVersion>()

  useEffect(() => {
    if (versionId) {
      getVersion(Number(versionId)).then(setVersion)
    }
  }, [versionId])

  return (
    <Space orientation="vertical" size={16} style={{ width: '100%' }}>
      {version && <VersionDescriptions version={version} />}
    </Space>
  )
}

export default Version
